export const deleteByProperty = (
  array: any[],
  propertyName: string | number,
  propertyValue: any,
): any[] => {
  const foundIndex = [...array].findIndex(
    element => element[propertyName] === propertyValue,
  )
  if (foundIndex === -1) {
    // tslint:disable-next-line:no-console
    console.warn(`Object by ${propertyName} with ${propertyValue} not found.`)
    return array
  }
  return [...array.slice(0, foundIndex), ...array.slice(foundIndex + 1)]
}

export const updateByProperty = (
  array: any[],
  propertyName: string | number,
  propertyValue: any,
  newValue: any,
) => {
  const foundIndex = [...array].findIndex(
    element => element[propertyName] === propertyValue,
  )

  if (foundIndex === -1) {
    // tslint:disable-next-line:no-console
    console.warn(`Object by ${propertyName} with ${propertyValue} not found.`)
    return [...array]
  }

  let calculatedNewValue = newValue
  if (typeof newValue === 'function') {
    calculatedNewValue = newValue(array[foundIndex])
  }
  return [
    ...array.slice(0, foundIndex),
    calculatedNewValue,
    ...array.slice(foundIndex + 1),
  ]
}

export const updateByQuestionProperty = (
  array: any[],
  propertyName: string | number,
  propertyValue: any,
  newValue: any,
) => {
  const foundIndex = [...array].findIndex(
    element => element[propertyName] === propertyValue,
  )

  if (foundIndex === -1) {
    // tslint:disable-next-line:no-console
    console.warn(`Object by ${propertyName} with ${propertyValue} not found.`)
    return [...array]
  }

  let calculatedNewValue = newValue
  if (typeof newValue === 'function') {
    calculatedNewValue = newValue(array[foundIndex])
  }
  return [
    ...array.slice(0, foundIndex),
    calculatedNewValue,
    ...array.slice(foundIndex + 1),
  ]
}
